import {
  UPDATE_RESPONSE_STATE,
  UPDATE_TIMING_STATE,
} from '../../sharedActionTypes';
const INITIAL_STATE = {
  responsesLoaded: {},
  timingsLoaded: {},
};

const responseLoading = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_RESPONSE_STATE:
      return { ...state, responsesLoaded: action.payload };
    case UPDATE_TIMING_STATE:
      return { ...state, timingsLoaded: action.payload };
    default:
      return state;
  }
};
export default responseLoading;
